const Company = {

    // FIELDS
    "company": "Company",
    "name": "Name",
    "logo": "Logo",
    "description": "Description",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "company": "Company",
    "filter": "Company Filter",

    // TABLE HEADER
    "table_name": "COMPANY NAME",
    "table_logo": "LOGO",
    "table_email": "EMAIL",
    "table_phone": "PHONE",
    "table_description": "DESCRIPTION",

    // ERROR
    "error_name": "Enter Company Name",
    "error_logo": "Select Logo",
    "error_description": "Enter Description",
    "error_email": "Enter Email",
    "error_phone": "Enter Phone",
    "error_address": "Enter Address",
    "error_status": "Select Status",

}

export default Company;

